
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suport-clienti/[categoryUrlKey]",
      function () {
        return require("private-next-pages/suport-clienti/[categoryUrlKey]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suport-clienti/[categoryUrlKey]"])
      });
    }
  